import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "", testid }) => (
  <motion.div
    className={className}
    data-testid={testid}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);
